// extracted by mini-css-extract-plugin
export default {"content":"D6ErXCq0NKDdKjh00DVu","row":"VkUu5trrkCU80iK1nilz"};